import {Alert, Button, TextInput} from "omoplay";
import {useState} from "react";
import BrokenCheckIcon from "../assets/images/icon.check.broken.svg"
import {postChangePassword, postFindPwdAuthCode, postFindPwdAuthorization} from "../api/auth/auth.api";

const FindPwdPage = () => {
    const [id, setId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [validAccount, setValidAccount] = useState();
    const [userAuthCode, setUserAuthCode] = useState("");
    const [validAuthCode, setValidAuthCode] = useState();
    const [changePassword, setChangePassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [changeSuccess, setChangeSuccess] = useState(false);

    return (
        /* 모바일 레이아웃: `h-screen` + 중앙정렬은 내용이 화면보다 길 때 위쪽이 잘리고 스크롤로도 닿을 수 없다.
           `minWidth: 540px` 은 375px 기기에서 화면 밖으로 나가는 직접 원인이었다.
           상세 설명은 `JoinPage.js` 주석 참고. */
        <div className="w-full min-h-screen min-h-[100dvh] flex login-background-gradient">
            <div className="flex-1 bg-white flex">
                <div className="m-auto w-full max-w-[458px] px-5 py-8 flex-col items-center gap-4">
                    {
                        changeSuccess ? (
                            <div className="w-full">
                                <div className="w-full flex-col flex-center-all gap-[32px] p-[32px]">
                                    <div className="flex flex-center-all gap-2">
                                        <img src={BrokenCheckIcon} alt="broken_check" />
                                        <div className="flex-align-center justify-center text-[24px] font-bold">
                                            비밀번호가 변경되었습니다
                                        </div>
                                    </div>
                                    <div className="w-full">
                                        <Button variants="primary"
                                                size="large"
                                                style={{width: "100%"}}
                                                value="로그인 페이지로 돌아가기"
                                                onClick={() => window.location.href = "/login"}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (

                            validAuthCode ? (
                                <div className="w-full">
                                    <div className="w-full flex-col flex-center-all gap-[32px] p-[32px]">
                                        <div className="flex-col flex-center-all gap-2">
                                            <img src={BrokenCheckIcon} alt="broken_check" />
                                            <div className="flex-align-center justify-center text-[24px] font-bold">
                                                비밀번호 재설정
                                            </div>
                                        </div>
                                        <div className="flex-col flex-center-all w-full p-[20px] bg-shape rounded-[8px] gap-2">
                                            <div className="flex-col gap-2 w-full">
                                                <label className="block text-gray-700 text-sm font-bold">
                                                    비밀번호 재설정
                                                </label>
                                                <TextInput placeholder="변경할 비밀번호를 입력해주세요."
                                                           type="password"
                                                           value={changePassword}
                                                           onChange={(e) =>
                                                               setChangePassword(e.target.value)} />
                                            </div>
                                            <div className="flex-col gap-2 w-full">
                                                <label className="block text-gray-700 text-sm font-bold">
                                                    비밀번호 재입력
                                                </label>
                                                <TextInput placeholder="동일한 비밀번호를 입력해주세요."
                                                           type="password"
                                                           value={confirmPassword}
                                                           onChange={(e) =>
                                                               setConfirmPassword(e.target.value)} />
                                            </div>
                                            {
                                                changePassword !== confirmPassword && (
                                                    <div className="text-red-500">비밀번호가 맞지 않습니다.</div>
                                                )
                                            }
                                        </div>
                                        <div className="w-full">
                                            <Button variants="primary"
                                                    disabled={changePassword.length === 0 || changePassword !== confirmPassword}
                                                    size="large"
                                                    style={{width: "100%"}}
                                                    value="비밀번호 재설정"
                                                    onClick={() => {
                                                        postChangePassword(id, changePassword).then(() => {
                                                            setChangeSuccess(true);
                                                        })
                                                    }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="flex justify-center text-[24px] font-bold" style={{marginBottom: "20px"}}>
                                        비밀번호 찾기
                                    </div>
                                    {
                                        validAccount === false && (
                                            <Alert title="계정 정보를 확인해주세요." type="error" withIcon={true}>
                                                입력한 휴대전화와 연결된 계정이 존재하지 않습니다.
                                            </Alert>
                                        )
                                    }
                                    <div className="flex-col gap-2 w-full">
                                        <div className="flex-col gap-2">
                                            <label className="block text-gray-700 text-sm font-bold">
                                                아이디
                                            </label>
                                            <TextInput placeholder="아이디를 입력해주세요."
                                                       value={id}
                                                       onChange={(e) =>
                                                           setId(e.target.value)} />
                                        </div>
                                        <div className="flex-col gap-2">
                                            <label className="block text-gray-700 text-sm font-bold">
                                                휴대전화번호
                                            </label>
                                            <TextInput placeholder="계정과 연결된 휴대전화를 입력해주세요."
                                                       value={phoneNumber}
                                                       onChange={(e) =>
                                                           setPhoneNumber(e.target.value)} />
                                        </div>
                                        {
                                            validAccount && (
                                                <div className="flex-col gap-2">
                                                    <label className="block text-gray-700 text-sm font-bold">
                                                        인증번호
                                                    </label>
                                                    <TextInput placeholder="알림톡으로 받은 인증번호를 입력해 주세요."
                                                               value={userAuthCode}
                                                               onChange={(e) =>
                                                                   setUserAuthCode(e.target.value)} />
                                                    {
                                                        validAuthCode === false && (
                                                            <div className="text-red-500">인증번호가 맞지 않습니다.</div>
                                                        )
                                                    }
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="w-full">
                                        {
                                            validAccount ? (
                                                <Button size="large" variants="primary" value="비밀번호 재설정"
                                                        style={{width: "100%"}}
                                                        onClick={() => {
                                                            postFindPwdAuthorization(id, userAuthCode).then(({data}) => {
                                                                setValidAuthCode(data === "success")
                                                            })
                                                        }} />
                                            ) : (
                                                <Button size="large" variants="primary" value="인증번호 받기"
                                                        style={{width: "100%"}}
                                                        onClick={() => {
                                                            postFindPwdAuthCode(id, phoneNumber).then(({data}) => {
                                                                if (data === "Empty") {
                                                                    setValidAccount(false)
                                                                } else {
                                                                    setValidAccount(true)
                                                                }
                                                            })
                                                        }} />
                                            )
                                        }
                                    </div>
                                </>
                            )
                        )
                    }
                </div>
            </div>
            {/* 오른쪽 그라디언트 여백 — 좁은 화면에서는 숨긴다(종전의 `window.innerWidth` 1회 계산은 회전에 반응하지 않았다) */}
            <div className="hidden sm:flex flex-1 flex-center-all"></div>
        </div>
    );
};
export default FindPwdPage;
